import { assign } from 'lodash';
import React, { useState } from 'react';

type Props = {
  onClick?: () => void;
  size?: number; // 按钮直径，默认 56
  title?: string; // 鼠标悬停时显示的提示文字
  className?: string; // 额外 className（比如你使用 Tailwind）
  pageAiVisible?: any;
};

export default function FloatingAIButton({
  onClick,
  size = 20,
  title = 'AI',
  className = '',
  pageAiVisible = false,
}: Props) {
  const [hovered, setHovered] = useState(false);

  const defaultStyle: React.CSSProperties = {
    position: 'absolute',
    right: 0,
    top: 80,
    width: size,
    height: 80,
    borderRadius: 5,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    background: hovered ? '#3A32D1' : '#4F46E5', // indigo-600 背景
    color: '#FFFFFF', // 白字
    display: pageAiVisible ? 'none' : 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 0,
    boxShadow: hovered
      ? '0 6px 12px rgba(0,0,0,0.15)'
      : '0 3px 6px rgba(0,0,0,0.12)', // 优化后的更柔和阴影
    fontWeight: 600,
    fontSize: Math.max(12, Math.floor(size / 3.5)),
    cursor: 'pointer',
    userSelect: 'none',
    zIndex: 998,
    transition: 'right 300ms ease, transform 150ms ease, box-shadow 200ms ease',
  };

  return (
    <button
      type="button"
      aria-label={title}
      title={title}
      onClick={onClick}
      className={className}
      style={defaultStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      AI
    </button>
  );
}
